import { MetaSegment, VolunteerSearchLink } from "@skv/core";
import React from "react";

interface LocationListProps {
  locations: MetaSegment<string>[];
  onlineOrRemote: MetaSegment<string>;
}

// Used for SKV.NSW
export const LocationsListNoLink = (props: LocationListProps) => {
  let _locations = props.locations.map((n) => n.name).join("; ");

  if (props.onlineOrRemote) {
    _locations += " / Remote Friendly";
  }

  return <>{_locations}</>;
};

// Used for SKV.AU and SKV.NZ
export const LocationsListWithLink = (props: LocationListProps) => {
  const physicalLocations = props.locations.map(({ name, url, value }, idx) => (
    <React.Fragment key={idx}>
      <VolunteerSearchLink to={url} searchQuery={{ where: value }}>
        {name}
      </VolunteerSearchLink>
      {idx < props.locations.length - 1 && "; "}
    </React.Fragment>
  ));

  const onlineOrRemoteLink = props.onlineOrRemote ? (
    <VolunteerSearchLink
      to={props.onlineOrRemote.url}
      searchQuery={{
        where: props.onlineOrRemote.value,
      }}
    >
      {props.onlineOrRemote.name}
    </VolunteerSearchLink>
  ) : null;

  if (props.locations.length) {
    return props.onlineOrRemote ? (
      <>
        {physicalLocations} / {onlineOrRemoteLink}
      </>
    ) : (
      <>{physicalLocations}</>
    );
  }

  return onlineOrRemoteLink;
};
